/** Etiquetas visuales del rol (metadata; no sustituyen al teacher).
 * Pueden ir con Sin Teacher o con un maestro real.
 * Persistencia: JSON `etiquetas` en rol_clases_reemplazos (columna, no tabla nueva).
 */
export const TEACHER_EN_TRAINING = 'TEACHER EN TRAINING'
export const GRUPO_DE_APOYO = 'GRUPO DE APOYO'
export const CUBRE_TEACHER = 'CUBRE TEACHER'

export const ETIQUETA_TRAINING = 'training'
export const ETIQUETA_APOYO = 'apoyo'
export const ETIQUETA_CUBRE = 'cubre'

export function textoEtiquetaRol(etiqueta) {
  if (etiqueta === ETIQUETA_TRAINING) return TEACHER_EN_TRAINING
  if (etiqueta === ETIQUETA_APOYO) return GRUPO_DE_APOYO
  if (etiqueta === ETIQUETA_CUBRE) return CUBRE_TEACHER
  return null
}

export function colorEtiquetaRol(etiqueta) {
  if (etiqueta === ETIQUETA_TRAINING) return 'orange darken-1'
  if (etiqueta === ETIQUETA_APOYO) return 'teal darken-1'
  if (etiqueta === ETIQUETA_CUBRE) return 'indigo darken-1'
  return 'grey'
}

export function normalizarEtiquetaRol(etiqueta) {
  if (
    etiqueta === ETIQUETA_TRAINING ||
    etiqueta === ETIQUETA_APOYO ||
    etiqueta === ETIQUETA_CUBRE
  ) {
    return etiqueta
  }
  return null
}

export const SLOTS_ROL_TEACHER = [
  'lu1', 'ma1', 'mi1', 'ju1', 'vi1',
  'lu2', 'ma2', 'mi2', 'ju2', 'vi2',
  'lu3', 'ma3', 'mi3', 'ju3', 'vi3',
  'lu4', 'ma4', 'mi4', 'ju4', 'vi4',
  'lu5', 'ma5', 'mi5', 'ju5', 'vi5',
]

/** Con teacher en training el slot (lo que paga nómina) es el trainee; la celda muestra al titular. */
export function nombreTitularBloque(grupo, slot) {
  if (!grupo) return 'SIN TEACHER'
  if (grupo[`${slot}_tr`] && grupo[`${slot}_tit_n`]) return grupo[`${slot}_tit_n`]
  return grupo[`${slot}_n`] ? grupo[`${slot}_n`] : 'SIN TEACHER'
}

/** TEACHER COMODIN (y variantes) se muestran como SIN TEACHER. */
export function esNombreTeacherComodin(nombre) {
  if (nombre == null || nombre === '') return false
  const upper = String(nombre)
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
  return upper.indexOf('COMODIN') !== -1
}

/** Limpia slots con comodín para que la UI muestre SIN TEACHER. */
export function aplicarComodinComoSinTeacher(grupos) {
  for (const g of grupos || []) {
    for (const slot of SLOTS_ROL_TEACHER) {
      if (esNombreTeacherComodin(g[slot + '_n'])) {
        g[slot] = null
        g[slot + '_n'] = null
      }
    }
  }
}

function parseEtiquetasMap(raw) {
  if (!raw) return {}
  if (typeof raw === 'object' && !Array.isArray(raw)) return { ...raw }
  try {
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch (e) {
    return {}
  }
}

/** Aplica `slot_etiqueta` en cada grupo desde rol_clases_reemplazos.etiquetas */
export function aplicarEtiquetasTeachersRol(grupos, rolReemplazo) {
  const mapaRep = {}
  for (const r of rolReemplazo || []) {
    if (r && r.idgrupo != null) mapaRep[Number(r.idgrupo)] = r
  }

  for (const g of grupos || []) {
    const rep = mapaRep[Number(g.iderp)]
    const etFromRep = parseEtiquetasMap(rep && rep.etiquetas)
    const etFromGrupo = parseEtiquetasMap(g.etiquetas_rol)
    const et = { ...etFromGrupo, ...etFromRep }

    for (const slot of SLOTS_ROL_TEACHER) {
      g[`${slot}_etiqueta`] = et[slot] || null
    }
  }
}

/** Slots de la semana operativa 1–5 (lu/ma/mi/ju/vi). */
export function slotsSemanaRol(semana) {
  const s = Number(semana) || 1
  return ['lu', 'ma', 'mi', 'ju', 'vi'].map((d) => `${d}${s}`)
}

export function grupoTieneEtiquetaSemana(grupo, etiqueta, semana) {
  if (!grupo || !etiqueta) return false
  return slotsSemanaRol(semana).some((slot) => grupo[`${slot}_etiqueta`] === etiqueta)
}

export function contarEtiquetasSemana(grupos, semana) {
  let training = 0
  let apoyo = 0
  let cubre = 0
  for (const g of grupos || []) {
    for (const slot of slotsSemanaRol(semana)) {
      const e = g[`${slot}_etiqueta`]
      if (e === ETIQUETA_TRAINING) training++
      if (e === ETIQUETA_APOYO) apoyo++
      if (e === ETIQUETA_CUBRE) cubre++
    }
  }
  return { training, apoyo, cubre, total: training + apoyo + cubre }
}
